// tslint:disable:component-selector
import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'button[app-view-rounded-button]',
  templateUrl: './view-rounded-button.component.html',
  styleUrls: ['./view-rounded-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewRoundedButtonComponent implements OnInit {

  @Input()
  icon: string;

  @Input()
  iconPlacement: 'left' | 'right' = 'left';

  @Input()
  label: string;

  @Input()
  compact = false;

  @Input()
  buttonType: 'outline' | 'solid' = 'outline';

  @Input()
  shadow: boolean;

  constructor() { }

  ngOnInit() {
  }

}
